import { render, staticRenderFns } from "./Roads.vue?vue&type=template&id=5ce3d3cc"
import script from "./Roads.vue?vue&type=script&lang=js"
export * from "./Roads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports